import React, {Fragment} from 'react'
import {Row, Button, Typography, Col} from 'antd';
import {ACCESS_TOKEN} from "../../constants";
import {setAuthToken} from "../../api";
import routesConfig from "../../routesConfig";

const {Title, Text} = Typography


const RegisterPrompt = ({onRegister, onLogout}) => (
    <Fragment>
        <Row>
            <Text className='color-primary my-1 text-justify'>
                لطفا برای استفاده از خدمات رورو اطلاعات کاربری خود را تکمیل کنید
            </Text>
        </Row>
        <Button type="primary" size="large" block style={{borderRadius: "5px"}}
                onClick={e => {
                    e.preventDefault();
                    onRegister && onRegister()
                }}>
            تکمیل اطلاعات
        </Button>
        <Button block style={{color: 'red', border: 0, background: 'transparent'}}
                onClick={e => {
                    e.preventDefault();
                    console.log("salam behnam")
                    onLogout && onLogout()
                }}>
            خروج
        </Button>
    </Fragment>)

const LoginPrompt = ({ onLogin }) => (
    <Col className="p-1">
        <Row>
            <Text className='color-primary my-1 text-justify'>
                لطفا برای استفاده از خدمات رورو ثبت‌نام کنید یا وارد حساب کاربری خود شوید
            </Text>
        </Row>
        <Button type="primary" size="large" block style={{borderRadius: "5px"}}
                onClick={e => {
                    e.preventDefault();
                    onLogin && onLogin()
                }}>
            ثبت‌نام | ورود
        </Button>
    </Col>)

export default function ProtectedAreaView({
                                              userRegistered, onRegister,
                                              userLoggedIn, onLogin, children, onLogout
                                          }) {


    if (userRegistered) {
        return children
    } else if (userLoggedIn) {
        return <RegisterPrompt onRegister={onRegister} onLogout={onLogout}/>
    } else {
        return <LoginPrompt onLogin={onLogin}/>
    }

}
